<template>
	<!-- 设置license -->
	<el-dialog
	  title="license管理"
	  :visible.sync="dialogVisible"
	  v-if="dialogVisible"
	  @close="close"
	  width="500px">
	  <div class="tab_box">
				<div class="brandMessage">
					<span>品牌标识：{{brandData.brandIdentify}}</span>
					<span>品牌名称：{{brandData.brandName}}</span>

				</div>
				<div class="brandMessage">
					<span>License状态：{{licenseState}}</span>
				</div>
		    	<div class="status">
			    	启用状态：
			    	<el-radio v-model="status" label="0">启用</el-radio>
						<el-radio v-model="status" label="1">禁用</el-radio>
				  </div>
				  <div class="ipRange">
				  	IP范围：
			    	<el-input
			    		style="width: 400px;"
							size="small"
				      v-model="ipRange"
				      placeholder="请输入IP范围">
				    </el-input>
				  </div>
		    	<div class="licenseTime">
			    	license有效时间：
			    	<el-date-picker
			    		style="width: 250px;"
							size="small"
				      v-model="licenseTime"
				      type="daterange"
					    value-format="yyyy-MM-dd"
				      range-separator="至"
				      start-placeholder="开始日期"
				      end-placeholder="结束日期">
				    </el-date-picker>
				  </div>
					<div class="license">
						<div>
							<div>模块</div>
							<div>模块有效时间</div>
							<div>人数</div>
						</div>
						<div v-for="item in moduleData">
							<div>
								<el-checkbox v-model="item.checked">{{item.name}}</el-checkbox>
							</div>
							<el-date-picker
								:disabled="!item.checked"
								size="small"
					      v-model="item.durationTime"
					      type="daterange"
					      value-format="yyyy-MM-dd"
					      range-separator="至"
					      start-placeholder="开始日期"
					      end-placeholder="结束日期">
					    </el-date-picker>
					    <el-input-number v-model="item.num" :disabled="!item.checked" size="small" :controls="false" :min="0"></el-input-number>
						</div>
					</div>
					<div style="display: flex; justify-content: space-between;">
						<el-button @click="confirmLicneseDel" type="text" style="color: red;">删除</el-button>
						<div>
						  <el-button @click="close">取消</el-button>
			  			<el-button type="primary" @click="confirmCommit">授权</el-button>
			  		</div>
  				</div>

		</div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import authTree from "./components/authTree";
import {
	Encrypt,
	Decrypt
} from '@/utils/crypto';

export default {
	name: "uploadLicense",
	components: {
		authTree
	},
	data() {
		return {
			queryKeys: ["lc","ph","sm","em","wb","ln"],
			dialogVisible	: false,
			// license状态
			licenseState: "--",
			brandData: {},
			// 启用状态
			status: "0",
			// license有效时间
			licenseTime: "",
			ipRange: "",
			// 模块权限列表
			moduleData: [{
				name: "IM",
				id: 1,
				checked: false,
				durationTime: [],
				num: 0
			},{
				name: "电话",
				id: 2,
				checked: false,
				durationTime: [],
				num: 0
			},{
				name: "短信",
				id: 3,
				checked: false,
				durationTime: [],
				num: 0
			},{
				name: "邮件",
				id: 4,
				checked: false,
				durationTime: [],
				num: 0
			},{
				name: "微博",
				id: 5,
				checked: false,
				durationTime: [],
				num: 0
			},{
				name: "培训",
				id: 6,
				checked: false,
				durationTime: [],
				num: 0
			}]
		}
	},
	computed: {
		...mapGetters([
			"userInfo"
		])
	},
	mounted(){
	},
	methods: {
		open(brandData){
			// console.log(brandData);
			this.brandData = brandData;
			this.dialogVisible = true;
			this.requestLicense();
		},

    // 获取license信息
    requestLicense(){
    	this.$api.ocsLicenseGet(this.brandData.brandIdentify).then(res=>{
    		console.log(res);
    		if(res.errcode != 0) return false;
    		const { licenseContent,message } = res.data;
    		this.licenseState = message;

    		if(!licenseContent) {
    			this.resetLicenseItem();
    		}else{
    			this.setLicenseItem(licenseContent);
    		}

    	})

    },

    confirmCommit(){
		this.$confirm("确认提交吗？","消息",{
			type: "warning"
		}).then(()=>{
			this.handleAuth();
		}).catch(()=>{
			// console.log("取消");
		})
    },

    // 提交设置
    handleAuth(){

    	// 表单验证
    	for(let data of this.moduleData){
    		if(data.checked && data.durationTime.length<2){
    			this.$message.error(`请选择"${data.name}"的有效时间`);
    			return false;
    		}
    	}

    	function data2Query(key,data){
    		let num = "",
    				startTime = "",
  					endTime = "";
    		if(data.checked){
    			num = data.num;
    			startTime = data.durationTime?data.durationTime[0]:"";
    			endTime = data.durationTime?data.durationTime[1]:"";
    		}
    		return {
					[key]: num,
    			[key+"St"]: startTime,
    			[key+"Et"]: endTime
  			}
    	}

    	let itemsData = {};
    	for(let i = 0; i < this.moduleData.length; i++){
    		let _data = data2Query(this.queryKeys[i],this.moduleData[i]);
    		if(_data) Object.assign(itemsData, _data);
    	}

    	let licenseData = {
    			brandIdentify: this.brandData.brandIdentify,  // 品牌code
			    status: this.status,   //状态  0 正常   1锁定
			    startTime: this.licenseTime ? this.licenseTime[0] : '',   //license有效开始时间
			    endTime: this.licenseTime ? this.licenseTime[1] : '', //license有效结束时间
			    ipArea: this.ipRange,
			    ... itemsData,
			    /*lc:"moduleData.num",  //livechat（IM） 授权用户数量
			    ph:"o1S0dd5jiMq2blpBRHlXlQ==",  //电话 授权用户数量
			    sm:"o1S0dd5jiMq2blpBRHlXlQ==",   //短信 授权用户数量
			    em:"o1S0dd5jiMq2blpBRHlXlQ==",   //邮件 授权用户数量
			    wb:"o1S0dd5jiMq2blpBRHlXlQ==",    //微博  授权用户数量
			    ln:"o1S0dd5jiMq2blpBRHlXlQ==",    //培训 授权用户数量
			    lcSt:"U5x5j/LJlxSyTpOOSF5+CQ==",   ///livechat（IM） 有效开始时间
			    lcEt:"NwrSWyRp8TXL51qWZ62tjQ==",  //livechat（IM） 有效结束时间
			    phSt:"U5x5j/LJlxSyTpOOSF5+CQ==",
			    phEt:"NwrSWyRp8TXL51qWZ62tjQ==",
			    smSt:"U5x5j/LJlxSyTpOOSF5+CQ==",
			    smEt:"NwrSWyRp8TXL51qWZ62tjQ==",
			    emSt:"U5x5j/LJlxSyTpOOSF5+CQ==",
			    emEt:"NwrSWyRp8TXL51qWZ62tjQ==",
			    wbSt:"U5x5j/LJlxSyTpOOSF5+CQ==",
			    wbEt:"NwrSWyRp8TXL51qWZ62tjQ==",
			    lnSt:"U5x5j/LJlxSyTpOOSF5+CQ==",
			    lnEt:"NwrSWyRp8TXL51qWZ62tjQ=="*/
			}
			console.log(`发送数据:${licenseData}`)
			for(let key in licenseData){
				licenseData[key] = Encrypt(licenseData[key]);
			}
			this.$api.oscLicenseSet(
				this.brandData.brandIdentify,
				licenseData
			).then(res=>{
				if(res.errcode != 0) return false;

    		const { licenseContent,message } = res.data;
    		this.licenseState = message;
    		if(!licenseContent) {
    			this.resetLicenseItem();
    		}else{
    			this.setLicenseItem(licenseContent);
    		}

				this.$message({
            type: 'success',
            message: '操作成功!'
        });
			})
			// console.log(licenseData);
    },
    confirmLicneseDel(){
		this.$confirm("删除license后，当前的license将永久失效，该品牌需重新配置license系统才可正常用，请确认","删除License",{
			type: "error"
		}).then(()=>{
			this.oscLicenseDelete();
		}).catch(()=>{
			console.log("取消");
		})
    },
    // 删除license
    oscLicenseDelete(){
    	this.$api.oscLicenseDelete(this.brandData.brandIdentify)
    	.then(res=>{
    		if(res.errcode != 0) return false;
    		this.requestLicense();
    		this.$message({
            type: 'success',
            message: '操作成功!'
        });
    	})
    },

    // 设置license勾选项
    setLicenseItem(licenseContent){
    	// 解密
  		for(let key in licenseContent){
  			licenseContent[key] = Decrypt(licenseContent[key]);
  		}
  		console.log(licenseContent);
  		// 设置授权项
  		for(let i = 0; i < this.queryKeys.length; i++){
  			let itemKey = this.queryKeys[i];
  			if(typeof(licenseContent[itemKey]) != "undefined"){
  				this.moduleData[i].checked = true;
  				this.moduleData[i].durationTime = [licenseContent[itemKey+"St"],licenseContent[itemKey+"Et"]];
  				this.moduleData[i].num = licenseContent[itemKey];
  			}else{
  				this.moduleData[i].checked = false;
  				this.moduleData[i].durationTime = [];
  				this.moduleData[i].num = 0;
  			}
  		}

  		this.ipRange = licenseContent.ipArea;
  		this.licenseTime  = [licenseContent.startTime||"",licenseContent.endTime||""];
    },

    resetLicenseItem(){
			this.status = this.$options.data().status;
			this.ipRange = this.$options.data().ipRange;
			this.licenseTime = this.$options.data().licenseTime;
    	this.moduleData = this.$options.data().moduleData;
    },
    close(){
    	Object.assign(this.$data, this.$options.data.call(this));
    }
	}
}
</script>

<style lang="scss" scoped>
.brandMessage{
	margin-bottom: 10px;
	display: flex;
	flex-flow: row wrap;
	span + span{
		margin-left: 20px;
	}
}
.status,
.ipRange,
.licenseTime{
	margin-bottom: 10px;
}
.license{
	margin-bottom: 10px;
	& > div{
		margin-bottom: 5px;
		display: flex;
		width: 100%;
		justify-content: space-between;
		align-items: center;
		&>div:nth-child(1){
			width: 60px;
		}
		&>div:nth-child(2){
			width: 250px;	
		}
		&>div:nth-child(3){
			width: 60px;
		}
	}
}
</style>
